export { default } from './SpeedDialIcon';